// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/shield-x.js';

import { paths } from '../generated/shield-x';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('shield-x', Original, paths);
